import React, { useEffect, useState } from 'react';
import './Application.css';
import ComponentHeader from '../../generic-components/ComponentHeader/ComponentHeader';
import ClayLayout from '@clayui/layout';
import {
    Column,
    FileData,
    getDetailsValue,
    matchMakingBasicBusinessInforFields,
    matchMakingBasicPersonalInfoFields,
    matchMakingBusinessProfileInfoField,
    matchMakingDubaiMarketInfoFields,
    PartnerSelectionRow,
    UploadedFileDataColumns
} from '../../utils/Config';
import ViewOnlyDynamicTable from '../../generic-components/viewOnlyDynamicTable/ViewOnlyDynamicTable';
import { useApiMutation } from '../../apis/useApi';
import { toast } from 'react-toastify';
import MeetingTable from '../../generic-components/meetingTable/MeetingTable';
import {
    secondaryButtonStyle,
    upComingMeetingListTableColumn
} from '../../config';
import CutButton from '../../generic-components/customCutButton/CutButton';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs, { Dayjs } from 'dayjs';
import { submitWorkflowTask } from '../../apis/apiClient';
import MatchMakingPartnerSelection from '../../components/MatchMakingPartnerSelection/MatchMakingPartnerSelection';
import ClayModal, { useModal } from '@clayui/modal';
import ClayForm from '@clayui/form';
// import { submitWorkflowTask } from '../../apis/workFlowApis';
import ClayButton from '@clayui/button';
import { FieldValues, useForm } from 'react-hook-form';

const ApplicationDetails = () => {
    const [isBasicInfoInfoExpand, setIsBasicInfoExpand] = useState(true);
    const [isBusinessDetailInfoInfoExpand, setIsBusinessDetailInfoExpand] =
        useState(true);
    const [isFactsheetDetailInfoInfoExpand, setIsFactsheetDetailInfoExpand] =
        useState(true);
    const [isMeetingInfoExpand, setIsMeetingInfoExpand] = useState(true);
    const [
        isDisqualificationCommentVisible,
        setDisqualificationCommentVisible
    ] = useState(true);
    const [eventDetails, setEventDetails] = useState<any>();
    const [matchMakingData, setMatchMakingData] = useState<any>({});
    const [documentData, seDocumentData] = useState<FileData[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const { matchMakingId, matchMakingPartnerId } = useParams();
    const [upcomingMeetingData, setUpcomingMeetingData] = useState<
        { meetingDateTime: string }[]
    >([]);
    const [selectedMeetingData, setSelectedMeetingData] = useState<
        { meetingDateTime: string }[]
    >([]);
    const [selectedMeetingDate, setSelectedMeetingDate] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [shareFactsheetWithPartners, setShareFactsheetWithPartners] =
        useState<PartnerSelectionRow[]>([]);
    const [matchMakingParnterData, setMatchMakingPartnerData] = useState<any>(
        {}
    );
    const [selectedMeetingDataWithPartner, setSelectedMeetingDataWithPartner] =
        useState<{ meetingDateTime: string }[]>([]);
    const {
        observer: observer2,
        onOpenChange: onOpenChange2,
        open: open2
    } = useModal();

    const {
        control,
        register,
        watch,
        setError,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm<FieldValues>({
        mode: 'onChange'
    });
    const getCustomMatchMakingValue = (key: string) => {
        const value = matchMakingData?.[key];
        
        if (key === 'productTechnologyReadiness') {
            return getDetailsValue(value?.name);
        }
        
        if (Array.isArray(value)) {
            const names = value
                .map((item) => {
                    const name =
                        typeof item === 'object' && 'name' in item
                            ? item.name
                            : String(item);
                    return name.replace(/\s*\(.*?\)\s*/g, '').trim();
                })
                .filter(Boolean);

            return names.length > 0 ? names.join(', ') : '-';
        }
        if (value && typeof value === 'object' && 'name' in value) {
            return value.name?.replace(/\s*\(.*?\)\s*/g, '').trim();
        }
        return getDetailsValue(value) ?? '-';
    };
    const navigate = useNavigate();
    const newMatchMakingBasicPersonalInfoFields =
        matchMakingBasicPersonalInfoFields?.slice(5)?.filter((field) => {
            if (field?.key == 'otherValueForBIDProgramReference')
                return (
                    getCustomMatchMakingValue(
                        'whereYourCompanyHearAboutBIDProgram'
                    ) == 'Others'
                );
            return true;
        });

    const newMatchMakingBusinessProfileInfoField1 =
        matchMakingBusinessProfileInfoField?.slice(0, 5).filter((field) => {
            if (field?.key == 'otherTypeOfBusinessModel')
                return (
                    getCustomMatchMakingValue('requestorBusinessModelType') ==
                    'Others'
                );
            return true;
        });

    const newMatchMakingBusinessProfileInfoField2 =
        matchMakingBusinessProfileInfoField?.slice(5).filter((field) => {
            if (field?.key == 'otherIndustryVertical')
                return (
                    getCustomMatchMakingValue('requestorIndustryVertical') ==
                    'Others'
                );
            if (field?.key == 'otherCompanyCurrentFundingStage')
                return (
                    getCustomMatchMakingValue(
                        'requestorCompanyCurrentFundingStage'
                    ) == 'We have received funding through alternative means'
                );
            return true;
        });
    const newMatchMakingDubaiMarketInfoFields =
        matchMakingDubaiMarketInfoFields?.filter((field) => {
            if (field?.key == 'otherAnswerForDubaiStartup')
                return (
                    getCustomMatchMakingValue(
                        'howRequestorAreReadyToOpenCompany'
                    ) === 'Other'
                );
            else if (field?.key === 'otherAnswerForTodaySell')
                return (
                    getCustomMatchMakingValue(
                        'requestorAnswerForTodaysSellInDubaiOrUAE'
                    ) === 'Other'
                );
            else if (field?.key === 'otherAnswerForChallanges')
                return getCustomMatchMakingValue(
                    'requestorBiggestChallangesInUAEStratup'
                )
                    ?.split(',')
                    .map((s: string) => s.trim().toLowerCase())
                    .some((s: string) => s === 'other' || s === 'others');
            else if (field?.key == 'otherCategoriesWantedToConnectInDubai')
                return getCustomMatchMakingValue(
                    'requestorWantedCategoriesToBeConnected'
                )
                    ?.split(',')
                    .map((s: string) => s.trim().toLowerCase())
                    .some((s: string) => s === 'other' || s === 'others');
            else if (field?.key == 'otherSpecificationForReachedOut') {
                return (
                    getCustomMatchMakingValue(
                        'requestorReachedOutThemInPast'
                    ) === 'Other'
                );
            }
            return true;
        });

    const fetchMatchMakingData = useApiMutation<any, {}>(
        `/o/c/matchmakingrequestors/${matchMakingId}`,
        'get',
        {
            onSuccess: (data) => {
                const document = data?.matchMakingToAttachment.map(
                    (item: any) => ({
                        objectEntryId: item?.objectEntryId,
                        documentName: item?.attachment?.name,
                        href: item?.attachment?.link.href
                    })
                );
                const formattedData = [
                    data.firstSlot,
                    data.secondSlot,
                    data.thirdSlot
                ]
                    .filter(Boolean)
                    .sort((a, b) => dayjs(a).valueOf() - dayjs(b).valueOf())
                    .map((slot) => ({
                        meetingDateTime: dayjs(slot)
                            .local()
                            .format('DD/MM/YYYY hh:mm A')
                    }));
                const selectedSlot = [data.requestorSelectedSlot]
                    .filter(Boolean)
                    .sort((a, b) => dayjs(a).valueOf() - dayjs(b).valueOf())
                    .map((slot) => ({
                        meetingDateTime: dayjs(slot)
                            .local()
                            .format('DD/MM/YYYY hh:mm A')
                    }));
                if (
                    data?.requestorToPartners &&
                    data?.requestorToPartners?.length > 0
                ) {
                    const factsheetShareWithPartner = data?.requestorToPartners
                        ?.filter((item: any) => {
                            return [
                                'interestedEngagementStarted',
                                'closeSuccessful',
                                'closeUnsuccessful'
                            ].includes(item?.meetingStatus?.key || '');
                        })
                        ?.map((item: any) => {
                            return {
                                id: item?.id
                                    ? String(item.id)
                                    : String(Math.random()),
                                companyId: item?.companyId || item?.id || '',
                                companyName: item?.companyName,
                                industry: item?.industry,
                                status: item?.meetingStatus?.name ?? '-'
                            };
                        });

                    setShareFactsheetWithPartners(factsheetShareWithPartner);
                    // setSelectedPartners(factsheetShareWithPartner);
                }

                setSelectedMeetingData(selectedSlot);
                setUpcomingMeetingData(formattedData);
                seDocumentData(document);
                setMatchMakingData(data);
                setIsLoading(false);
            },
            onError: (error: any) => {
                console.error('Fetch error:', error);
                setIsLoading(false);
                toast.error('Failed to fetch matchmaking data', {
                    theme: 'light',
                    autoClose: 4000
                });
            }
        }
    );

    const updateMatchMakingRequestorDetails = useApiMutation<any, {}>(
        `o/c/matchmakingrequestors/${matchMakingId}`,
        'patch',
        {
            onSuccess: (data) => {
                toast.success('Meeting slot confirmed', {
                    theme: 'light',
                    autoClose: 2000
                });
                navigate('/application');
                setIsLoading(false);
            },
            onError: (error: any) => {
                console.error('Update error:', error);
            }
        }
    );

    useEffect(() => {
        setIsLoading(true);
        fetchMatchMakingData.mutate({
            data: {},
            params: {
                p_auth: (window as any)?.Liferay?.authToken,
                nestedFields: 'matchMakingToAttachment,requestorToPartners',
                restrictFields: 'actions'
            }
        });
    }, [matchMakingId]);

    const handleSelected = (record: any) => {
        const selectedSlot = dayjs(
            record?.meetingDateTime,
            'DD/MM/YYYY hh:mm A'
        )
            .utc()
            .toISOString();
        setErrorMessage('');
        setSelectedMeetingDate(selectedSlot);
    };

    const confirmMeetingSlot = async () => {
        if (selectedMeetingDate == '') {
            setErrorMessage('Please select one time slot for meeting');
            return;
        }
        const payload: any = {
            classPK: matchMakingId,
            transition: 'slot-selected',
            workflowTaskId: matchMakingData?.workflowTaskId
        };

          await updateMatchMakingRequestorDetails.mutateAsync({
              data: {
                  requestorSelectedSlot: selectedMeetingDate,
                  requestorStatus: {
                      key: 'meetingArrangedWithRequestor',
                      name: 'Meeting Arranged With Requestor'
                  }
              },
              params: {
                  p_auth: (window as any)?.Liferay?.authToken
              }
          });

        await submitWorkflowTask(
            payload,
            '/api/v1/workflow/process-task-by-user'
        );
    };

    const fetchMatchMakingPartnerData = useApiMutation<any, {}>(
        `/o/c/matchmakingpartners/${matchMakingPartnerId}`,
        'get',
        {
            onSuccess: (data) => {
                setMatchMakingPartnerData(data);
                if (data?.partnerSelectedSlot) {
                    const selectedSlot = [data?.partnerSelectedSlot]
                        .filter(Boolean)
                        .map((slot) => ({
                            meetingDateTime: dayjs(slot)
                                .local()
                                .format('DD/MM/YYYY hh:mm A')
                        }));
                    setSelectedMeetingDataWithPartner(selectedSlot);
                }
            },
            onError: (error: any) => {
                console.error('Fetch error:', error);
                setIsLoading(false);
                toast.error('Failed to fetch matchmaking data', {
                    theme: 'light',
                    autoClose: 4000
                });
            }
        }
    );

    useEffect(() => {
        setIsLoading(true);
        window.scrollTo(0, 0);
        if (Number(matchMakingPartnerId) > 0) {
            fetchMatchMakingPartnerData.mutate({
                data: {},
                params: {
                    p_auth: (window as any)?.Liferay?.authToken,
                    restrictFields: 'actions'
                }
            });
        }
    }, [matchMakingPartnerId]);

    // useEffect(() => {
    //     if (
    //         matchMakingParnterData &&
    //         matchMakingParnterData?.meetingStatus?.key == 'scheduled'
    //     ) {
    //         onOpenChange2(true);
    //     }
    // }, [matchMakingParnterData]);

    const updatePartnerDetails = useApiMutation<any, {}>(
        `o/c/matchmakingpartners/${matchMakingPartnerId}`,
        'patch',
        {
            onSuccess: (data) => {
                // toast.success('Meeting slot confirmed', {
                //     theme: 'light',
                //     autoClose: 2000
                // });
                navigate('/');
                setIsLoading(false);
                // onOpenChange2(false);
            },
            onError: (error: any) => {
                console.error('Update error:', error);
                // onOpenChange2(false);
            }
        }
    );
    const handleConfirm = async () => {
        await updatePartnerDetails.mutateAsync({
            data: {
                meetingStatus: {
                    key: 'completed',
                    name: 'Completed'
                }
            },
            params: {
                p_auth: (window as any)?.Liferay?.authToken
            }
        });
    };

      const getEventData = useApiMutation<any, {}>(
          `/o/c/matchmakingevents/${matchMakingData?.eventId}`,
          'get',
          {
              onSuccess: (details: any) => {
                  if (details) {
                      setEventDetails(details);
                  }

                  setIsLoading(false);
              },
              onError: (error) => {
                  setIsLoading(false);
              }
          }
      );

      useEffect(() => {
          setIsLoading(true);
          if (matchMakingData?.eventId) {
              getEventData.mutate({
                  data: {}
              });
          }
      }, [matchMakingData?.eventId]);

    return (
        <div className="match-making-details">
            <div className="d-flex align-items-center gap-2">
                <p className="detail-content">
                    Status: {matchMakingData?.requestorStatus?.name}
                </p>
                {Boolean(eventDetails?.eventName) && (
                    <p className="detail-content">
                        Event Name: {eventDetails?.eventName}
                    </p>
                )}
            </div>

            {['disqualified', 'disqualifiedAfterMeeting'].includes(
                matchMakingData?.requestorStatus?.key
            ) && (
                <div className="card-body accordian-section mt-4">
                    <ComponentHeader
                        title="Disqualification Reason & Comments"
                        setIsRequestedInfoExpand={
                            setDisqualificationCommentVisible
                        }
                        isRequestedInfoExpand={isDisqualificationCommentVisible}
                        isArrowIcon={true}
                    />
                    <div
                        className={
                            isDisqualificationCommentVisible
                                ? 'expand'
                                : 'collapse'
                        }
                    >
                        <div className="ib-hr"></div>
                        <label className="pt-0">
                            {matchMakingData?.rejectionOrRevisionReason
                                ?.name && (
                                <>
                                    <h1
                                        className="match-making-details-subheading"
                                        style={{ marginBottom: '6px' }}
                                    >
                                        Rejection Reason
                                    </h1>
                                    <div
                                        className="detail-content"
                                        style={{ margin: '0 0 10px' }}
                                    >
                                        {
                                            matchMakingData
                                                ?.rejectionOrRevisionReason
                                                ?.name
                                        }
                                    </div>
                                </>
                            )}
                            <h1
                                className="match-making-details-subheading"
                                style={{ marginBottom: '6px' }}
                            >
                                Comment
                            </h1>
                            <div className="detail-content m-0">
                                {matchMakingData?.rejectionComment || '-'}
                            </div>
                        </label>
                    </div>
                </div>
            )}

            {matchMakingData?.requestorStatus?.key ===
                'pendingQualificationCall' && (
                <div className="card-body accordian-section mt-4">
                    <ComponentHeader
                        title="Choose Upcoming Meeting"
                        setIsRequestedInfoExpand={setIsMeetingInfoExpand}
                        isRequestedInfoExpand={isMeetingInfoExpand}
                        isArrowIcon={true}
                    />
                    <div
                        className={isMeetingInfoExpand ? 'expand' : 'collapse'}
                    >
                        <div className="ib-hr"></div>
                        <div className="pt-0">
                            <MeetingTable
                                columns={upComingMeetingListTableColumn}
                                data={upcomingMeetingData}
                                showCheckbox={true}
                                onSelect={handleSelected}
                            />
                            {errorMessage && (
                                <div className="error-message mt-2">
                                    <p>{errorMessage}</p>
                                </div>
                            )}
                            <ClayLayout.ContentSection className="button-group-container mt-4 mb-0 d-flex justify-content-end">
                                <CutButton
                                    title="Cancel"
                                    buttonType="submit"
                                    disabled={false}
                                    primaryButtonStyle={secondaryButtonStyle}
                                />
                                <CutButton
                                    title="Confirm"
                                    buttonType="button"
                                    onClick={confirmMeetingSlot}
                                    disabled={false}
                                />
                            </ClayLayout.ContentSection>
                        </div>
                    </div>
                </div>
            )}
            {(matchMakingData?.requestorStatus?.key ===
                'meetingProposalWithPartner' ||
                selectedMeetingData?.length > 0) &&
                selectedMeetingDataWithPartner?.length == 0 && (
                    <div className="card-body accordian-section mt-4">
                        <ComponentHeader
                            title="Confirmed Meeting Date"
                            setIsRequestedInfoExpand={setIsMeetingInfoExpand}
                            isRequestedInfoExpand={isMeetingInfoExpand}
                            isArrowIcon={true}
                        />
                        <div
                            className={
                                isMeetingInfoExpand ? 'expand' : 'collapse'
                            }
                        >
                            <div className="ib-hr"></div>
                            <div className="pt-0">
                                <MeetingTable
                                    columns={upComingMeetingListTableColumn}
                                    data={selectedMeetingData}
                                    showCheckbox={false}
                                />
                            </div>
                        </div>
                    </div>
                )}
            {selectedMeetingDataWithPartner?.length > 0 && (
                <div className="card-body accordian-section mt-4">
                    <ComponentHeader
                        title="Confirmed Meeting Date With Partner"
                        setIsRequestedInfoExpand={setIsMeetingInfoExpand}
                        isRequestedInfoExpand={isMeetingInfoExpand}
                        isArrowIcon={true}
                    />
                    <div
                        className={isMeetingInfoExpand ? 'expand' : 'collapse'}
                    >
                        <div className="ib-hr"></div>
                        <div className="pt-0">
                            <MeetingTable
                                columns={upComingMeetingListTableColumn}
                                data={selectedMeetingDataWithPartner}
                                showCheckbox={false}
                            />
                        </div>
                    </div>
                </div>
            )}

            <div className="card-body accordian-section mt-4">
                <ComponentHeader
                    title="Basic Information"
                    setIsRequestedInfoExpand={setIsBasicInfoExpand}
                    isRequestedInfoExpand={isBasicInfoInfoExpand}
                    isArrowIcon={true}
                />
                <div className={isBasicInfoInfoExpand ? 'expand' : 'collapse'}>
                    <div className="ib-hr"></div>
                    <div className="pt-0">
                        <h2 className="match-making-details-subheading">
                            Personal and Contact details
                        </h2>
                        <ClayLayout.Row justify="start" className="content-gap">
                            {matchMakingBasicPersonalInfoFields
                                ?.slice(0, 5)
                                ?.map((field) => {
                                    const colSize =
                                        field?.key !==
                                            'whereYourCompanyHearAboutBIDProgram' &&
                                        field?.key !==
                                            'otherValueForBIDProgramReference'
                                            ? 3
                                            : 12;
                                    const marginBottom = [
                                        'requestorWorkEmail'
                                    ]?.includes(field?.key)
                                        ? 'mb-0'
                                        : 'mb-3';
                                    return (
                                        <ClayLayout.Col
                                            key={field.key}
                                            xl={colSize}
                                            lg={colSize}
                                            md={colSize}
                                            sm={colSize}
                                            xs={colSize}
                                            className={marginBottom}
                                        >
                                            <div key={field.key}>
                                                <p className="mb-1 paragraph-text">
                                                    {field.label}
                                                </p>
                                                <p className="detail-content m-0">
                                                    {getCustomMatchMakingValue(
                                                        field?.key
                                                    )}
                                                </p>
                                            </div>
                                        </ClayLayout.Col>
                                    );
                                })}
                        </ClayLayout.Row>
                        <div>
                            {newMatchMakingBasicPersonalInfoFields?.map(
                                (field) => (
                                    <div>
                                        <p className="match-making-info-heading mt-4">
                                            {' '}
                                            {field.label}
                                        </p>
                                        <p className="match-making-info-description">
                                            {' '}
                                            {getCustomMatchMakingValue(
                                                field?.key
                                            )}
                                        </p>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                    <div className="pt-4">
                        <h2 className="match-making-details-subheading">
                            Basic Business Details
                        </h2>
                        <ClayLayout.Row justify="start" className="content-gap">
                            {matchMakingBasicBusinessInforFields
                                ?.filter((field) => {
                                    const value = getCustomMatchMakingValue(
                                        field?.key
                                    );
                                    return value && value !== '-';
                                })
                                ?.map((field) => {
                                    const value = getCustomMatchMakingValue(
                                        field?.key
                                    );

                                    const isFullWidth =
                                        field?.key ===
                                        'whereYourCompanyHearAboutBIDProgram';

                                    const colSize = isFullWidth ? 12 : 3;

                                    const noMarginKeys = [
                                        'requestorBusinessIncorporationYear',
                                        'requestorCompanyWebsiteURL'
                                    ];

                                    const marginBottom = noMarginKeys.includes(
                                        field?.key
                                    )
                                        ? 'mb-0'
                                        : 'mb-3';

                                    return (
                                        <ClayLayout.Col
                                            key={field?.key}
                                            xl={colSize}
                                            lg={colSize}
                                            md={colSize}
                                            sm={colSize}
                                            xs={colSize}
                                            className={marginBottom}
                                        >
                                            <div>
                                                <p className="mb-1 paragraph-text">
                                                    {field?.label}
                                                </p>
                                                <p className="detail-content m-0">
                                                    {value}
                                                </p>
                                            </div>
                                        </ClayLayout.Col>
                                    );
                                })}
                        </ClayLayout.Row>
                    </div>
                </div>
            </div>
            <div className="card-body accordian-section mt-4">
                <ComponentHeader
                    title="Business Details"
                    setIsRequestedInfoExpand={setIsBusinessDetailInfoExpand}
                    isRequestedInfoExpand={isBusinessDetailInfoInfoExpand}
                    isArrowIcon={true}
                />
                <div
                    className={
                        isBusinessDetailInfoInfoExpand ? 'expand' : 'collapse'
                    }
                >
                    <div className="ib-hr"></div>
                    <div className="pt-0">
                        <h2 className="match-making-details-subheading">
                            Business Profile
                        </h2>
                        <ClayLayout.Row justify="start" className="content-gap">
                            {newMatchMakingBusinessProfileInfoField1?.map(
                                (field) => {
                                    const colSize = [
                                        'requestorBusinessModelType',
                                        'otherTypeOfBusinessModel',
                                        'requestorAnnualRevenue',
                                        'requestorCurrentBusinessValuation',
                                        'requestorWorkEmail',
                                        'numberOfEmployees'
                                    ]?.includes(field?.key)
                                        ? 3
                                        : 12;
                                    return (
                                        <ClayLayout.Col
                                            key={field.key}
                                            xl={colSize}
                                            lg={colSize}
                                            md={colSize}
                                            sm={colSize}
                                            xs={colSize}
                                            className="mb-3"
                                        >
                                            <div key={field.key}>
                                                <p className="mb-1 paragraph-text">
                                                    {field.label}
                                                </p>
                                                {field?.key == 'attachedMOA' ? (
                                                    <ViewOnlyDynamicTable
                                                        columns={
                                                            UploadedFileDataColumns
                                                        }
                                                        data={documentData}
                                                        onDataChange={
                                                            seDocumentData
                                                        }
                                                        readOnlyView={true}
                                                        title="uploadedFileData"
                                                        backgroundColor="#E1F7FD66"
                                                    />
                                                ) : (
                                                    <p className="detail-content m-0">
                                                        {getCustomMatchMakingValue(
                                                            field?.key
                                                        )}
                                                    </p>
                                                )}
                                            </div>
                                        </ClayLayout.Col>
                                    );
                                }
                            )}
                        </ClayLayout.Row>
                        <div>
                            {newMatchMakingBusinessProfileInfoField2?.map(
                                (field) =>
                                    field.key == 'attachedMOA' ? (
                                        <>
                                            <h2 className="match-making-subheading mt-4">
                                                Corporate Presentation
                                            </h2>
                                            <ViewOnlyDynamicTable
                                                columns={
                                                    UploadedFileDataColumns
                                                }
                                                data={documentData}
                                                onDataChange={seDocumentData}
                                                readOnlyView={true}
                                                title="uploadedFileData"
                                                backgroundColor="#E1F7FD66"
                                            />
                                        </>
                                    ) : (
                                        <div>
                                            <p className="match-making-info-heading mt-4">
                                                {' '}
                                                {field.label}
                                            </p>
                                            <p className="match-making-info-description">
                                                {' '}
                                                {getCustomMatchMakingValue(
                                                    field?.key
                                                )}
                                            </p>
                                        </div>
                                    )
                            )}
                        </div>
                    </div>
                    <div className="ib-hr mt-2"></div>
                    <div className="pt-0">
                        <h2 className="match-making-details-subheading">
                            Dubai Market
                        </h2>
                        {newMatchMakingDubaiMarketInfoFields?.map((field) => (
                            <div>
                                <p className="match-making-info-heading mt-4">
                                    {' '}
                                    {field.label}
                                </p>
                                <p className="match-making-info-description">
                                    {' '}
                                    {getCustomMatchMakingValue(field?.key)}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {shareFactsheetWithPartners?.length > 0 &&
                !matchMakingPartnerId && (
                    <div className="card-body accordian-section mt-4">
                        <ComponentHeader
                            title="Partner with shared the factsheet"
                            setIsRequestedInfoExpand={
                                setIsFactsheetDetailInfoExpand
                            }
                            isRequestedInfoExpand={
                                isFactsheetDetailInfoInfoExpand
                            }
                            isArrowIcon={true}
                        />
                        <div
                            className={
                                isFactsheetDetailInfoInfoExpand
                                    ? 'expand'
                                    : 'collapse'
                            }
                        >
                            <div className="ib-hr"></div>
                            <MatchMakingPartnerSelection
                                availableCompanies={[]}
                                value={shareFactsheetWithPartners}
                                onChange={() => {}}
                                readOnly={true}
                            />
                        </div>
                    </div>
                )}
            {matchMakingParnterData?.meetingStatus?.key == 'scheduled' && (
                <ClayLayout.ContentSection className="button-group-container mt-4 mb-0 d-flex justify-content-end">
                    <CutButton
                        title="Meeting Completed"
                        buttonType="button"
                        disabled={isLoading}
                        onClick={() => onOpenChange2(true)}
                    />
                </ClayLayout.ContentSection>
            )}
            {open2 && (
                <ClayModal observer={observer2} className="custom-modal" center>
                    <ClayModal.Header
                        className="custom-madal-header"
                        style={{
                            color: '#003764',
                            fontSize: '24px',
                            fontWeight: '700'
                        }}
                    >
                        Meeting Confirmation
                    </ClayModal.Header>
                    <ClayForm onSubmit={handleSubmit(handleConfirm)}>
                        <ClayModal.Body>
                            <p
                                className="service-note-text"
                                style={{ color: '#003764', fontSize: '16px' }}
                            >
                                Is meeting completed with partner?
                            </p>
                        </ClayModal.Body>

                        <ClayModal.Footer
                            style={{ border: 'none' }}
                            className="pt-0"
                            last={
                                <ClayButton.Group
                                    spaced
                                    style={{ display: 'flex', gap: '16px' }}
                                >
                                    <CutButton
                                        onClick={() => onOpenChange2(false)}
                                        title="No"
                                        buttonType="button"
                                        disabled={false}
                                        primaryButtonStyle={
                                            secondaryButtonStyle
                                        }
                                    />
                                    <CutButton
                                        title="Yes"
                                        buttonType="submit"
                                        disabled={isLoading}
                                        onClick={handleSubmit(handleConfirm)}
                                    />
                                </ClayButton.Group>
                            }
                        />
                    </ClayForm>
                </ClayModal>
            )}
        </div>
    );
};

export default ApplicationDetails;
